export default function Alerts() {
  jQuery(document).ready(function ($) {
    let alert = $('.alerts');
    if (alert.length > 0) {
      function getHeight() {
        let alert = $('.alerts');
        let height = 0;
        if (alert.length > 0 && $(window).width() > 1100) {
          alert.each(function (num, elem) {
            if ($(elem).css('display') === 'block') {
              height += $(elem).height();
            }
          });
          let navChild = $('.nav__childContainer');
          let navChildTop = 70;
          let total = height + navChildTop;
          total = total.toString() + 'px';
          navChild.css('top', `${total}`);
        } else {
          let navChild = $('.nav__childContainer');
          navChild.css('top', '0');
        }
      }
      function closeAlert() {
        let dataId = $(this).data('id');
        let dataDate = $(this).data('date');
        document.cookie = `${dataId}=true; expires=${dataDate};`;
        $('.alerts__wrapper[data-id=' + dataId + ']').css('display', 'none');
        getHeight();
      }

      const alertClose = $('.alerts__close');
      $(window).on('load', getHeight);
      $(window).on('resize', getHeight);
      alertClose.on('click', closeAlert);
    }
  });
}
